import {
  ZONE_LOADING,
  ZONE_ERROR,

  ZONE_GET_LIST,
  ZONE_GET_ALL,
  ZONE_GET_TEMPLATES,
  ZONE_GET_FILTERS,
  ZONE_GET_TYPES,
  ZONE_ADD
} from "actions/zone/constants";

const initialState = {
  loading: false,
  errors: [],

  zoneList: [],
  zoneAll: [],
  zoneTemplates: [],
  zoneFilters: [],
  zoneSingle: {},
  zoneTypes: []
};

export default function (state = initialState, action) {
  let zoneList,
    zoneAll,
    index;
  switch (action.type) {
    case ZONE_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case ZONE_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case ZONE_GET_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        zoneList: action.payload,
      };
    case ZONE_GET_ALL:
      return {
        ...state,
        loading: false,
        errors: [],
        zoneAll: action.payload.content,
      };
    case ZONE_GET_TEMPLATES:
      return {
        ...state,
        loading: false,
        zoneTemplates: action.payload.content,
      };
    case ZONE_GET_FILTERS:
      return {
        ...state,
        loading: false,
        errors: [],
        zoneFilters: action.payload.content,
      };
    case ZONE_GET_TYPES:
      return {
        ...state,
        loading: false,
        errors: [],
        zoneTypes: action.payload.content,
      };
    case ZONE_ADD:
      zoneList = Object.assign({}, state.zoneList);
      zoneList.content = Object.assign([], zoneList.content);
      index = zoneList.content.findIndex(item => item.id === action.payload.id);
      if (index > -1) {
        zoneList.content[index] = action.payload;
      } else {
        zoneList.total_count += 1;
        zoneList.content.push(action.payload);
      }

      zoneAll = Object.assign([], state.zoneAll);
      index = zoneAll.findIndex(item => item.id === action.payload.id);
      if (index > -1) {
        zoneAll[index] = action.payload;
      } else {
        zoneAll.push(action.payload);
      }
      return {
        ...state,
        loading: false,
        errors: [],
        zoneList,
        zoneAll
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/zoneReducer.js